/* *
* 分页组件
* @module /src/components/BasePaginationr.vue
* @desc 列表分页组件
* @author wenghaocan@3ncto.com
* @date 2020年06月17日
* @param {String} [currentPage] - 当前页数
* @param {String} [pageSize] - 每页条数
* @param {String} [total] - 数据总数
* @example 调用示例
*  <base-pagination :currentPage="currentPage" :pageSize="pageSize" :total="total" @onChange="onChange" @onShowSizeChange="onChange"></base-pagination>
* */
<template>
    <div class="pagination-options" v-if="total > 0">
        <a-pagination
            v-model="current"
            show-size-changer
            show-quick-jumper
            :default-current="current"
            :default-pageSize="size"
            :total="total"
            :show-total="total => `共 ${total} 条`"
            :page-size.sync="size"
            :size="paginationSize"
            :page-size-options="options"
            @change="bindCurrentChange"
            @showSizeChange="bindSizeChange"
        />
    </div>
</template>
<script>
export default {
    name: "BasePagination",
    data() {
        return {
            current: 0,
            size: 0
        };
    },
    props: {
        currentPage: {
            require: true,
            type: Number
        },
        pageSize: {
            require: true,
            type: Number
        },
      paginationSize: {
            require: true,
            type: String
        },
        total: {
            require: true,
            type: Number
        },
        options: {
            type: Array,
            default: function () {
                return  ['10', '50', '100']
            }
        },
    },
	watch: {
		currentPage: {
			handler: function(val) {
				this.current = val
			},
			immediate: true,
			deep: true
        },
        pageSize: {
			handler: function(val) {
				this.size = val
			},
			immediate: true,
			deep: true
		},
	},
    methods: {
        // 分页事件-修改当前页码
        bindCurrentChange(current, pageSize) {
            this.$emit('onChange', current, pageSize)
        },
        // 分页事件-修改当前页数
        bindSizeChange(current, pageSize) {
            this.$emit('onShowSizeChange', 1, pageSize)
        }
    },
    mounted() {

    }
};
</script>
<style lang="less" scoped>
.pagination-options {
    padding-top: 16px;
    text-align: center;
    
}
</style>
